import { format, formatDistanceToNowStrict } from 'date-fns';

/** "Just now" for the first minute, then a strict relative time ("2 minutes ago"). */
export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  if ((Date.now() - then) / 1000 < 60) return 'Just now';
  return formatDistanceToNowStrict(new Date(iso), { addSuffix: true });
}

/**
 * Compact, suffix-less relative time for dense UI: "Just now", then "5m", "3h",
 * "2d", "4mo", "1y". Same first-minute threshold as {@link formatRelativeTime};
 * pair it with {@link formatAbsoluteTime} in a hover tooltip for the full date.
 */
export function formatRelativeTimeShort(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  if ((Date.now() - then) / 1000 < 60) return 'Just now';
  return formatDistanceToNowStrict(new Date(iso))
    .replace(/ years?/, 'y')
    .replace(/ months?/, 'mo')
    .replace(/ days?/, 'd')
    .replace(/ hours?/, 'h')
    .replace(/ minutes?/, 'm')
    .replace(/ seconds?/, 's');
}

/** Absolute timestamp for tooltips, short format: "Jul 23, 2026 at 6:37 PM". */
export function formatAbsoluteTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  return format(new Date(iso), "MMM d, yyyy 'at' h:mm a");
}
